/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module code-block/codeblockui
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
// import SplitButtonView from '@ckeditor/ckeditor5-ui/src/dropdown/button/splitbuttonview';
import { createDropdown, addListToDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
// import { getNormalizedAndLocalizedLanguageDefinitions } from './utils';

import htmlSourceCodeIcon from './theme/icons/htmlSourceCode.svg';
import './theme/css/style.css';

/**
 * The code block UI plugin.
 *
 * Introduces the `'htmlSourceCode'` dropdown.
 *
 * @extends module:core/plugin~Plugin
 */
export default class HtmlSourceCodeUI extends Plugin {
	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const t = editor.t;
		const componentFactory = editor.ui.componentFactory;
		// const normalizedLanguageDefs = getNormalizedAndLocalizedLanguageDefinitions( editor );
		// const defaultLanguageDefinition = normalizedLanguageDefs[ 0 ];

		componentFactory.add( 'htmlSourceCode', locale => {
			const command = editor.commands.get( 'htmlSourceCode' );
			// const dropdownView = createDropdown( locale, SplitButtonView );
			// const splitButtonView = dropdownView.buttonView;
			const view = new ButtonView( locale );

			view.set( {
				label: t( 'HTML 原始碼' ),
				tooltip: true,
				icon: htmlSourceCodeIcon,
				isToggleable: true
			} );

			view.bind( 'isOn' ).to( command, 'value', value => !!value );

			this.listenTo( view, 'execute', () => {
				editor.execute( 'htmlSourceCode' );
				editor.editing.view.focus();
			} );

			// view.on( 'execute', () => {
			// 	editor.execute( 'htmlSourceCode');

			// 	editor.editing.view.focus();
			// } );

			// dropdownView.on( 'execute', evt => {
			// 	editor.execute( 'htmlSourceCode', {
			// 		language: evt.source._htmlSourceCodeLanguage,
			// 		forceValue: true
			// 	} );

			// 	editor.editing.view.focus();
			// } );

			// dropdownView.class = 'ck-code-block-dropdown';
			// dropdownView.bind( 'isEnabled' ).to( command );

			// addListToDropdown( dropdownView, this._getLanguageListItemDefinitions( normalizedLanguageDefs ) );

			return view;
		} );
	}

	/**
	 * A helper returning a collection of the `htmlSourceCode` dropdown items representing languages
	 * available for the user to choose from.
	 *
	 * @private
	 * @param {Array.<module:code-block/codeblock~HtmlSourceCodeLanguageDefinition>} normalizedLanguageDefs
	 * @returns {Iterable.<module:ui/dropdown/utils~ListDropdownItemDefinition>}
	 */
	// _getLanguageListItemDefinitions( normalizedLanguageDefs ) {
	// 	const editor = this.editor;
	// 	const command = editor.commands.get( 'htmlSourceCode' );
	// 	const itemDefinitions = new Collection();

	// 	for ( const languageDef of normalizedLanguageDefs ) {
	// 		const definition = {
	// 			type: 'button',
	// 			model: new Model( {
	// 				_htmlSourceCodeLanguage: languageDef.language,
	// 				label: languageDef.label,
	// 				withText: true
	// 			} )
	// 		};

	// 		definition.model.bind( 'isOn' ).to( command, 'value', value => {
	// 			return value === definition.model._htmlSourceCodeLanguage;
	// 		} );

	// 		itemDefinitions.add( definition );
	// 	}

	// 	return itemDefinitions;
	// }
}
